/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminPlatformMarketsRow } from '../openapi-types.gen.js';
import { type useGetAdminPlatformMarketsArgs, useGetAdminPlatformMarketsSpec } from '../specs/admin.spec.gen.js';

export type { GetAdminPlatformMarketsRow } from '../openapi-types.gen.js';
export type { useGetAdminPlatformMarketsArgs } from '../specs/admin.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): limit, cursor.
 */
const _useGetAdminPlatformMarkets = createHook(useGetAdminPlatformMarketsSpec);
export const useGetAdminPlatformMarkets = _useGetAdminPlatformMarkets as (args: useGetAdminPlatformMarketsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminPlatformMarkets>;


/**
 * Hover/intent prefetch companion for `useGetAdminPlatformMarkets`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetAdminPlatformMarkets();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminPlatformMarkets = createPrefetchHook(useGetAdminPlatformMarketsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminPlatformMarketsArgs>;
